function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 14a.5.5 0 000-1H13a1 1 0 01-1-1V2a1 1 0 011-1h.5a.5.5 0 000-1H13a2 2 0 00-2 2v10a2 2 0 002 2h.5zM4 2a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V2zM1 14a2 2 0 002-2V2a2 2 0 00-2-2H.5a.5.5 0 000 1H1a1 1 0 011 1v10a1 1 0 01-1 1H.5a.5.5 0 100 1H1z"
});

function SvgColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgColumns;